// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"755bbfc8","455":"1c5cd58c","977":"133b845c"}[chunkId] + ".chunk.js";
};